module.exports = __webpack_public_path__ + "assets/create_document.ea899ef1.svg";